// 用户管理模块国际化 - 英文
export default {
  search: {
    placeholder: 'Search username, email or phone',
    status: 'Status',
    role: 'Role',
    all: 'All',
    enabled: 'Enabled',
    disabled: 'Disabled',
    pending: 'Pending',
    allRoles: 'All Roles',
    admin: 'Admin',
    user: 'User',
    refresh: 'Refresh',
    add: 'Add User',
    button: 'Search'
  },
  stats: {
    total: 'Total Users',
    active: 'Active Users',
    inactive: 'Disabled Users',
    pending: 'Pending Users',
    normal: 'Active Users',
    disable: 'Disabled Users'
  },
  table: {
    title: 'User List',
    id: 'User ID',
    info: 'User Info',
    phone: 'Phone',
    enterprise: 'Enterprise',
    role: 'Role',
    status: 'Status',
    lastLogin: 'Last Login',
    createdAt: 'Created At',
    actions: 'Actions',
    detail: 'Detail',
    edit: 'Edit',
    more: 'More',
    disable: 'Disable',
    enable: 'Enable',
    disableUser: 'Disable User',
    enableUser: 'Enable User',
    bindCompany: 'Bind Enterprise',
    resetPassword: 'Reset Password'
  },
  modal: {
    addTitle: 'Add User',
    editTitle: 'Edit User',
    detailTitle: 'User Detail',
    bindTitle: 'Bind Enterprise',
    statusTitle: 'User Status Confirmation',
    resetTitle: 'Reset Password Confirmation',
    resetSuccess: 'Password Reset Successful',
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmBind: 'Confirm Bind',
    confirmReset: 'Confirm Reset',
    currentUser: 'Current User',
    currentEnterprise: 'Current Enterprise',
    currentRole: 'Role in Enterprise',
    targetEnterprise: 'Target Enterprise',
    statusConfirm: {
      enable: 'Are you sure to enable user',
      disable: 'Are you sure to disable user',
      enableDesc: 'After enabling, the user will regain access and can log in again.',
      disableDesc: 'After disabling, the user cannot log in and all ongoing operations will be interrupted.',
      info: 'User Info',
      enterprise: 'Enterprise',
      currentStatus: 'Current Status',
      warning: 'Disable Warning',
      enableTip: 'Enable Info'
    },
    resetConfirm: {
      desc: 'This will reset the password for user {username}. Continue?',
      tip: 'Note: After reset, a random 8-digit password will be generated and sent to the user\'s email.',
      success: 'Password reset info has been sent to {email}',
      newPwd: 'New Password',
      userEmail: 'User Email'
    }
  },
  form: {
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    enterprise: 'Enterprise',
    usernameRequired: 'Please enter username',
    usernameMin: 'Username must be at least 2 characters',
    usernameMinLength: 'Username must be at least 2 characters',
    usernamePlaceholder: 'Please enter username',
    emailRequired: 'Please enter email',
    emailValid: 'Please enter a valid email address',
    emailPlaceholder: 'Please enter email',
    phoneRequired: 'Please enter phone',
    phoneMax: 'Phone max 20 characters',
    phoneValid: 'Please enter a valid phone number',
    phonePlaceholder: 'Please enter phone',
    enterpriseRequired: 'Please select enterprise',
    enterprisePlaceholder: 'Please select enterprise',
    targetEnterpriseRequired: 'Please select target enterprise'
  },
  message: {
    refresh: 'Data refreshed',
    showAll: 'Show all users',
    showActive: 'Filter enabled users',
    showInactive: 'Filter disabled users',
    showPending: 'Filter pending users',
    getStatsFail: 'Failed to get user stats',
    getListFail: 'Failed to get user list',
    getEnterpriseFail: 'Failed to get enterprise list',
    getDetailFail: 'Failed to get user detail',
    updateStatusFail: 'Failed to update user status',
    bindFail: 'Failed to bind enterprise',
    updateFail: 'Failed to update user',
    addFail: 'Failed to add user',
    resetFail: 'Failed to reset password',
    updateSuccess: 'User info updated',
    addSuccess: 'User added',
    bindSuccess: 'User {username} successfully bound to enterprise: {enterprise}',
    statusSuccess: 'User {username} {action}',
    resetSuccess: 'Password reset successful',
    autoFilter: 'Auto filtered by enterprise: {company}',
    getCustomerEnterpriseFail: 'Failed to get enterprise info'
  },
  role: {
    admin: 'Admin',
    user: 'User',
    unknown: 'Unknown'
  },
  status: {
    normal: 'Active',
    disabled: 'Disabled',
    pending: 'Pending',
    unknown: 'Unknown'
  },
  // Add unified naming and missing keys
  filter: {
    status: 'Status',
    role: 'Role',
    all: 'All',
    enable: 'Enable',
    disable: 'Disable',
    pending: 'Pending',
    allRoles: 'All Roles',
    admin: 'Admin',
    user: 'User'
  },
  addUser: {
    button: 'Add User'
  },
  refresh: {
    button: 'Refresh'
  },
  edit: {
    editTitle: 'Edit User',
    addTitle: 'Add User',
    role: 'Role',
    status: 'Status',
    enterprise: 'Enterprise',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  detail: {
    title: 'User Detail',
    avatar: 'Avatar',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    enterprise: 'Enterprise',
    role: 'Role',
    status: 'Status',
    lastLogin: 'Last Login',
    createdAt: 'Created At',
    userId: 'User ID',
    confirm: 'OK'
  },
  bindCompany: {
    title: 'Bind Enterprise',
    currentUser: 'Current User',
    currentEnterprise: 'Current Enterprise',
    notBound: 'Not Bound',
    currentRole: 'Current Role',
    targetEnterprise: 'Target Enterprise',
    enterpriseRequired: 'Please select enterprise',
    enterprisePlaceholder: 'Please select enterprise',
    confirmBind: 'Confirm Bind',
    cancel: 'Cancel'
  },
  toggleStatus: {
    confirmTitle: 'Status Change Confirmation',
    confirmMessage: 'Are you sure to change user {username} status to {action}?',
    disableWarning: 'Disable Warning',
    disableDescription: 'After disabling, the user cannot log in.',
    enableDescription: 'After enabling, the user can log in normally.',
    userInfo: 'User Info',
    enterprise: 'Enterprise',
    currentStatus: 'Current Status',
    cancel: 'Cancel',
    disable: 'Disable',
    enable: 'Enable'
  },
  resetPassword: {
    confirmTitle: 'Reset Password Confirmation',
    warningTitle: 'Reset Password Warning',
    confirmMessage: 'Are you sure to reset password for user {username}?',
    note: 'After reset, the new password will be sent to the user by email.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    successTitle: 'Password Reset Successful',
    successMessage: 'Password has been reset',
    username: 'Username',
    newPassword: 'New Password',
    email: 'Email',
    successInfo: 'The new password has been sent to {email}'
  }
}